import {
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  InputRef,
  Popover,
  Row,
  Select,
  Skeleton,
  Space,
  Table,
  TableColumnType,
  Tooltip,
} from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import ItemsService, {
  UnitTypes,
  UnitTypesOption,
} from "../../Services/ItemsService";
import { useTheme } from "../../Context/ThemeContext";
import { useClient } from "../../Context/ClientContext";
import { ColumnsType } from "antd/es/table";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  FilterOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import UnitModel from "./UnitModel";
import InvoiceExportService from "../../Services/InvoiceExportDetails";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { notificationContext } from "../../Common/PageRoute";
import { FilterDropdownProps } from "antd/es/table/interface";
import {
  TextSearchTableEnum,
  TextSearchTableOption,
} from "../../Common/SearchTableOptions";
import { findUserOnlyOnePremission } from "../Users/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";

interface IUnitDataType {
  key: string;
  sno: number;
  companyId: string;
  id: number;
  name: string;
  type: string;
  shortName: string;
  tAmount: number;
  system: boolean;
}

const UnitsItems = () => {
  const { currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  const { themeData } = useTheme();
  const { openNotification } = useContext(notificationContext);
  const searchInput = useRef<InputRef>(null);
  const searchSelect = useRef<any>(null);
  const [openDropdown, setOpenDropdown] = useState<DataIndex | null>(null);
  type DataIndex = keyof IUnitDataType;

  const [width, setWidth] = useState<any>(window.innerWidth);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(15);
  const [unitsList, setUnitsList] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [searchUnit, setSearchUnit] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [openModel, setOpenModel] = useState<boolean>(false);
  const [unitData, setUnitData] = useState<any>({});
  const [trigger, setTrigger] = useState<boolean>(false);
  const [exportType, setExportType] = useState<number>(-1);
  const [exportUnitData, setExportUnitData] = useState<any[]>([]);
  const [filter, setfilter] = useState<any>({
    sortCol: "",
    sortDir: "",
  });
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [searchColumnCount, setSearchColumnCount] = useState<number>(0);

  const [searchColumns, setSearchColumns] = useState<any>({
    name: "",
    type: null,
    shortName: "",
  });
  const [searchColumnsDropDown, setSearchColumnsDropDown] = useState<{
    unitNameDropEnum: TextSearchTableEnum;
    shortNameDropEnum: TextSearchTableEnum;
  }>({
    unitNameDropEnum: TextSearchTableEnum.contains,
    shortNameDropEnum: TextSearchTableEnum.contains,
  });

  useEffect(() => {
    if (currentClient?.id && (exportType === -1 || exportType)) {
      const requestModel = {
        unitName: searchColumns.name,
        unitNameDropEnum: searchColumnsDropDown.unitNameDropEnum,
        type: searchColumns.type,
        shortName: searchColumns.shortName,
        shortNameDropEnum: searchColumnsDropDown.shortNameDropEnum,
      };
      getUnitsList(
        currentClient?.id,
        exportType >= 1 ? 0 : (page - 1) * pageSize,
        exportType >= 1 ? 0 : pageSize,
        filter.sortCol,
        filter.sortDir,
        searchUnit,
        searchColumnCount,
        requestModel
      );
    } else if (currentClient?.id === null) {
      console.error("currentClient is null Items");
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    trigger,
    page,
    pageSize,
    searchUnit,
    // location.pathname,
    filter.sortCol,
    filter.sortDir,
    exportType,
    searchColumns,
  ]);

  // --------- Get Units TableData API ---------
  const getUnitsList = async (
    clientId: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    searchColumnCount?: number,
    requestModel?: any
  ) => {
    if (exportType < 1) {
      setLoading(true);
    }
    await ItemsService.getUnitsList(
      clientId,
      start,
      length,
      sortCol,
      sortDir,
      search,
      searchColumnCount,
      requestModel
    )
      .then((res: any) => {
        if (res.result?.items?.length > 0) {
          // console.log(res.result.items);
          let unitData = res.result.items?.map((v: any, i: any) => {
            return {
              companyId: v?.companyId,
              name: v?.name,
              type: v?.type,
              shortName: v?.shortName,
              sno: v?.sno,
              id: v?.id,
              system: v?.system,
            };
          });

          if (exportType >= 1) {
            setExportUnitData(unitData);
            if (exportType === 1) {
              exportCsv(unitData);
            } else if (exportType === 2) {
              exportPDF(unitData);
            } else if (exportType === 3) {
              exportExcel(unitData);
            }
          } else {
            setUnitsList(unitData);
            setLoading(false);
            // setTotalRecords(res.result?.totalRecords);
          }
          setTotalRecords(res.result?.totalRecords);
        } else if (res.result?.items?.length === 0) {
          setUnitsList([]);
          setTotalRecords(res.result.totalRecords);
        }
        setLoading(false);
      })
      .catch((ex: any) => {
        console.error(ex.message);
        setLoading(false);
        setUnitsList([]);
      });
  };

  const deleteUnitId = async () => {
    let res = await ItemsService.deleteUnitId(currentClient?.id, unitData?.id);
    if (res?.status) {
      console.log("data", res);
      setConfirmation(false);
      setTrigger((x) => !x);
      openNotification("success", "Unit deleted successfully");
    } else {
      setConfirmation(false);
      openNotification("error", res.message);
    }
  };

  // const handleSearch = (
  //   selectedKeys: string[] | any,
  //   confirm: any,
  //   dataIndex: DataIndex
  // ) => {
  //   console.log("handleSearch", dataIndex, selectedKeys, searchColumns);
  //   switch (dataIndex) {
  //     case "name":
  //       if (selectedKeys[0] || searchColumns.unitName) {
  //         setSearchColumns({
  //           ...searchColumns,
  //           unitName: selectedKeys[0],
  //         });
  //       }
  //       break;
  //     case "type":
  //       if (selectedKeys || searchColumns.type) {
  //         setSearchColumns({ ...searchColumns, type: selectedKeys });
  //       }
  //       break;
  //     case "shortName":
  //       if (selectedKeys[0] || searchColumns.shortName) {
  //         setSearchColumns({ ...searchColumns, shortName: selectedKeys[0] });
  //       }
  //       break;
  //   }
  //   confirm();
  //   setOpenDropdown(null); // Close the dropdown
  // };

  // Table Search Inide

  const handleSearch = (
    selectedKeys: string[] | any,
    confirm: any,
    dataIndex: DataIndex
  ) => {
    // console.log("handleSearch", dataIndex, selectedKeys, searchColumns);

    let prevValue = searchColumns[dataIndex]; // check this input value present or notPresent
    let newValue = selectedKeys; // user input filed value

    // console.log("newValue", prevValue, newValue);
    if (newValue?.length < 0) {
      confirm();
      setOpenDropdown(null);
      return;
    }

    let newSearchColumns = { ...searchColumns };
    switch (dataIndex) {
      case "name":
      case "shortName":
        newSearchColumns[dataIndex] = selectedKeys[0];
        break;
      case "type":
        newSearchColumns[dataIndex] = selectedKeys;
        break;
    }

    if (!prevValue && newValue?.length > 0) {
      setSearchColumnCount((prev) => prev + 1);
    }

    setSearchColumns(newSearchColumns);
    // console.log(searchColumnCount, "count", prevValue, newValue, selectedKeys);
    confirm();
    setOpenDropdown(null); // Close the dropdown
  };

  const handleDropdownText = (
    dataIndex: DataIndex,
    valDropDown: TextSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "name":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          unitNameDropEnum: valDropDown,
        });
        break;
      case "shortName":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          shortNameDropEnum: valDropDown,
        });
        break;
    }
  };

  // const handleReset = (
  //   clearFilters: () => void,
  //   confirm: FilterDropdownProps["confirm"],
  //   dataIndex: DataIndex
  // ) => {
  //   clearFilters();
  //   confirm();
  //   // console.log("dataIndex", dataIndex, searchColumns);

  //   switch (dataIndex) {
  //     case "name":
  //       if (searchColumns.name) {
  //         setSearchColumns({
  //           ...searchColumns,
  //           name: "",
  //         });
  //       }
  //       break;
  //     case "shortName":
  //       if (searchColumns.shortName) {
  //         setSearchColumns({ ...searchColumns, shortName: "" });
  //       }
  //       break;
  //     case "type":
  //       if (searchColumns.type) {
  //         setSearchColumns({ ...searchColumns, type: null });
  //       }
  //       break;
  //   }
  // };

  const handleReset = (
    clearFilters: () => void,
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    clearFilters();
    confirm();

    let prevValue = searchColumns[dataIndex]; // check this input value present or notPresent

    if (prevValue) {
      setSearchColumnCount((prev) => prev - 1);
    }
    if (prevValue) {
      setSearchColumns((prev: any) => {
        const newSearchColumns = { ...prev };
        delete newSearchColumns[dataIndex];
        return newSearchColumns;
      });
    }
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
    searchPlaceHolder?: string
  ): TableColumnType<IUnitDataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        {dataIndex === "type" ? (
          <Checkbox.Group
            options={UnitTypesOption}
            style={{
              marginBottom: 8,
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}
            // value={searchColumns.gstRate}
            value={selectedKeys}
            onChange={(e: any) => {
              setSelectedKeys(e ? [...e] : []);
            }}
          />
        ) : (
          <>
            <Select
              defaultValue={TextSearchTableEnum.contains}
              style={{
                width: "100%",
                maxWidth: "200px",
                marginBottom: "8px",
              }}
              onChange={(val: TextSearchTableEnum) => {
                setExportUnitData([]);
                handleDropdownText(dataIndex, val);
                // setTextTypeSearchColumn(val);
                // setType(1);
              }}
              options={TextSearchTableOption?.map((x: any) => ({
                value: x.value,
                label: x.label,
              }))}
            />

            <Input
              ref={searchInput}
              placeholder={`Search.. ${searchPlaceHolder}`}
              value={selectedKeys[0]}
              onChange={(e) => {
                // console.log(
                //   "Data",
                //   // e.target.value,
                //   Utils.getNumber(e.target.value),
                //   Utils.getNumber("")
                // );

                // const x = Utils.getFormattedNumber(e.target.value);
                // if (
                //   dataIndex === "purchasePrice" ||
                //   dataIndex === "salesPrice"
                // ) {
                //   setSelectedKeys(e.target.value ? [x] : []);
                // } else

                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() =>
                handleSearch(selectedKeys as string[], confirm, dataIndex)
              }
              style={{ marginBottom: 8, display: "block", width: "200px" }}
            />
          </>
        )}
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            // icon={<SearchOutlined />}
            size="small"
            style={{ width: 95 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters, confirm, dataIndex);
            }}
            size="small"
            style={{ width: 95 }}
          >
            Clear
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) =>
      searchPlaceHolder ? (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ) : (
        <FilterOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
    filterDropdownOpen: openDropdown === dataIndex,
    filterDropdownProps: {
      placement: "bottomLeft",
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setOpenDropdown(dataIndex);
        setTimeout(() => {
          if (dataIndex === "type") {
            searchSelect.current?.focus(); // Use focus for Select component
          } else {
            searchInput.current?.select(); // Use select for Input component
          }
        }, 100);
      } else {
        setOpenDropdown(null);
      }
    },
  });

  const permissionEdit = findUserOnlyOnePremission(
    "Master.Item.Unit.Edit",
    clientSpecificRole(),
    currentClient?.id!
  );

  const permissionDelete = findUserOnlyOnePremission(
    "Master.Item.Unit.Delete",
    clientSpecificRole(),
    currentClient?.id!
  );

  // --------- Units Table Columns  ---------
  const itemColumns: ColumnsType<IUnitDataType> = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      width: "5%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.sno}
        </Skeleton>
      ),
    },
    {
      title: "Full Name",
      dataIndex: "name",
      key: "name",
      width: "40%",
      sorter: true,
      defaultSortOrder: "ascend",
      filteredValue: searchColumns.name ? [searchColumns.name] : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.name}
        </Skeleton>
      ),
      ...getColumnSearchProps("name", "Full Name"),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "35%",
      sorter: true,
      filteredValue:
        searchColumns.type || searchColumns.type === false
          ? searchColumns.type
          : null,
      render: (_, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {UnitTypes[record?.type]}
        </Skeleton>
      ),
      ...getColumnSearchProps("type"),
    },
    {
      title: "Short Name",
      dataIndex: "shortName",
      key: "shortName",
      sorter: true,
      filteredValue: searchColumns.shortName ? [searchColumns.shortName] : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.shortName}
        </Skeleton>
      ),
      ...getColumnSearchProps("shortName", "Short Name"),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "edit",
      render: (record: IUnitDataType) =>
        record?.system === false ? (
          <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 1 }}
            title={false}
          >
            <Row gutter={8}>
              {permissionEdit && (
                <Col>
                  <Tooltip title="Edit" placement="top" color="#3D4998">
                    <EditOutlined
                      // className="ca-edit-btn"
                      style={{
                        color: "#444653",

                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setOpenModel(true);
                        setUnitData({
                          id: record?.id,
                          companyId: record?.companyId,
                          name: record?.name,
                          type: record?.type,
                          shortName: record?.shortName,
                        });
                      }}
                    />
                  </Tooltip>
                </Col>
              )}
              {permissionDelete && (
                <Col>
                  <Tooltip title="Delete" placement="top" color="red">
                    <DeleteOutlined
                      // className="ca-edit-btn"
                      onClick={() => {
                        setUnitData({ id: record.id, name: record.name });
                        setConfirmation(true);
                      }}
                      style={{
                        color: "red",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </Col>
              )}
            </Row>
          </Skeleton>
        ) : (
          <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 1 }}
            title={false}
          >
            <Row gutter={8}>
              {permissionEdit && (
                <Col>
                  <Tooltip title="Not Editable" placement="top" color="#3D4998">
                    <EditOutlined
                      style={{ color: "rgb(216 207 207)", cursor: "pointer" }}
                    />
                  </Tooltip>
                </Col>
              )}
              {permissionDelete && (
                <Col>
                  <Tooltip
                    title="Default unit are not delete"
                    placement="top"
                    color="#3D4998"
                  >
                    <DeleteOutlined
                      style={{ color: "rgb(216 207 207)", cursor: "pointer" }}
                    />
                  </Tooltip>
                </Col>
              )}
            </Row>
          </Skeleton>
        ),
    },
  ];

  //----- Table Ascending & Desending Order -----
  const tableSort = (pagination?: any, sort?: any, filter?: any) => {
    setfilter({
      sortCol: filter.column !== undefined ? filter.columnKey : "number",
      sortDir:
        filter.column !== undefined
          ? filter.order === "descend"
            ? "desc"
            : "asc"
          : "desc",
    });
    // console.log("sort1111111111111", sort?.TaxRate?.Rate, sort);
  };

  let path = "Unit List";
  const columnsA = ["S.No.", "Full Name", "Type", "Short Name"];

  const fieldMapping = {
    "S.No.": (item: any) => item?.sno,
    "Full Name": (item: any, index: number) => item?.name,
    Type: (item: any, index: number) => UnitTypes[item?.type],
    "Short Name": (item: any, index: number) => item?.shortName,
  };

  const generateFooterRow = (columns: string[]) => {
    return columns.map((col) => {});
  };

  const exportCsv = (exportData: any[]) => {
    InvoiceExportService.generateCSV(
      exportData,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      "",
      path,
      currentClient?.businessName
    );
    setExportType(0);
  };

  const exportPDF = (exportData: any[]) => {
    InvoiceExportService.generatePDF(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      path
    );
    setExportType(0);
  };

  const exportExcel = async (exportData: any[]) => {
    await InvoiceExportService.generateExcel(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      path
    );
    setExportType(0);
  };

  const content = (
    <Space direction="vertical">
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="CSV"
          onClick={() => {
            if (exportUnitData.length > 0) {
              exportCsv(exportUnitData);
            } else {
              setExportType(1);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          CSV
        </Button>
      </div>

      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="PDF"
          onClick={() => {
            if (exportUnitData.length > 0) {
              exportPDF(exportUnitData);
            } else {
              setExportType(2);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          PDF
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="XLSX"
          onClick={() => {
            if (exportUnitData.length > 0) {
              exportExcel(exportUnitData);
            } else {
              setExportType(3);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          XLSX
        </Button>
      </div>
    </Space>
  );

  return (
    <Card
      size="small"
      className="TableCard"
      style={{
        // marginTop: "6px",
        marginTop: 35,
        // padding: "48px 0px 0px 0px",
        boxShadow: "0px 0px 10px 0px #96A1C84D",
      }}
    >
      <div>
        <Row justify="space-between">
          <Col>
            <Row gutter={15}>
              {findUserOnlyOnePremission(
                "Master.Item.Unit.Add",
                clientSpecificRole(),
                currentClient?.id!
              ) && (
                <Col>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setOpenModel(true)}
                  >
                    Unit
                  </Button>
                </Col>
              )}

              <Col>
                {unitsList.length === 0 ? (
                  <Button icon={<DownloadOutlined />} disabled type="primary">
                    Export
                  </Button>
                ) : (
                  <Popover
                    content={content}
                    placement="rightTop"
                    trigger="hover"
                  >
                    <Button
                      type="default"
                      icon={<DownloadOutlined />}
                      // onClick={() => exportCsv()}
                    >
                      Export
                    </Button>
                  </Popover>
                )}
              </Col>
            </Row>
          </Col>
          <Col>
            <Input
              allowClear
              style={{ width: "220px" }}
              placeholder="Search.."
              onChange={(e: any) => {
                setLoading(true);
                if (!e.cancelable) {
                  //console.log("typeing user............");
                  const searchUnit = setTimeout(() => {
                    setPage(1);
                    setSearchUnit(e.target.value);
                  }, 1000);
                  setExportUnitData([]);
                  setExportType(-1);
                  return () => clearTimeout(searchUnit);
                } else {
                  // console.log("Click cancle............");
                  setSearchUnit(e.target.value);
                }
              }}
              suffix={loading || searchUnit ? "" : <SearchOutlined />}
            />
          </Col>
        </Row>
        <Table
          className={`Tabel-style table-${
            themeData?.componentSize ?? "middle"
          }`}
          // loading={tableLoading}
          style={{ overflowX: "clip" }}
          columns={itemColumns}
          locale={{
            triggerDesc: "",
            triggerAsc: "",
            cancelSort: "",
          }}
          dataSource={
            loading
              ? (Array.from({ length: pageSize }, (_, index) => ({
                  key: `loading-${index}`,
                })) as IUnitDataType[])
              : unitsList
          }
          pagination={{
            total: totalRecords,
            current: page,
            pageSize: pageSize,
            showSizeChanger: true,
            onChange: (page: number, pageSize: number) => {
              setPage(page);
              setPageSize(pageSize);
              setExportType(-1);
            },
            pageSizeOptions: ["15", "25", "50", "100"],
            showTotal: (totalRecords, page) =>
              `${page[0]}-${page[1]} of ${totalRecords} items`,
          }}
          onChange={tableSort}
          scroll={
            pageSize > 15 ? { y: window.innerHeight - 300 } : { y: undefined }
          }
        />
        {openModel && (
          <UnitModel
            open={true}
            data={unitData}
            onCancel={() => setOpenModel(false)}
            setTrigger={setTrigger}
          />
        )}

        {confirmation && (
          <ConfirmationModal
            open={confirmation}
            onNo={() => {
              setConfirmation(false);
            }}
            onYes={deleteUnitId}
            text={`Are you sure you want to ${unitData?.name}`}
          />
        )}
      </div>
    </Card>
  );
};

export default UnitsItems;
